import { motion } from "framer-motion";
import { Crown, Shield, Star, ArrowUpRight } from "@phosphor-icons/react";

const mods = [
    {
        handle: "@realcpat",
        role: "Lead Mod",
        icon: Crown,
        bio: "Backbone of the chat. The OG. Day-one energy and somehow always in the mod chat before anyone else.",
        badge: "OG",
        accent: "text-amber-300",
        testId: "mod-realcpat",
        link: "https://linktr.ee/realcpat",
        linkLabel: "Linktree",
    },
    {
        handle: "@tanoshark",
        role: "Lead Mod",
        icon: Shield,
        bio: "im Tanoshark ools lead mod been there since day 1 and people listen to me cuz yuh yk",
        badge: "Anchor",
        accent: "text-brand-cyan",
        testId: "mod-tanoshark",
        link: "https://twitch.tv/tanoshark",
        linkLabel: "Twitch",
    },
    {
        handle: "@rexynz04",
        role: "Goated Mod",
        icon: Star,
        bio: "Im Rexy the Goated Mod been here a few months loving the community we are buiding",
        badge: "Goated",
        accent: "text-brand-purple",
        testId: "mod-rexynz04",
        link: "https://linktr.ee/rexynz04",
        linkLabel: "Linktree",
    },
];

export const ModsGrid = () => {
    return (
        <section className="relative py-10 lg:py-14" data-testid="community-section">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="mb-10 max-w-2xl"
                >
                    <span className="eyebrow">Mod team</span>
                    <h2 className="font-display text-3xl sm:text-4xl text-white mt-2">
                        The crew running the <span className="gradient-text">show</span>
                    </h2>
                    <p className="text-white/55 mt-3 text-sm">
                        Without these three, the stream is a wildfire with no fire department. They keep the chat tight, the vibes high, and the chaos productive.
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    {mods.map((m, i) => (
                        <motion.a
                            key={m.handle}
                            href={m.link}
                            target="_blank"
                            rel="noreferrer"
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            className="group relative block rounded-2xl border border-white/10 bg-obsidian-900/60 p-6 card-tilt hover:border-brand-cyan/40 transition"
                            data-testid={m.testId}
                        >
                            <div className="flex items-start justify-between mb-6">
                                <div className="h-11 w-11 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
                                    <m.icon size={18} weight="fill" className={m.accent} />
                                </div>
                                <div className="px-2 py-0.5 rounded-full bg-white/5 border border-white/10">
                                    <span className="text-[10px] uppercase tracking-wider text-white/70 font-medium">{m.badge}</span>
                                </div>
                            </div>
                            <div className="eyebrow">{m.role}</div>
                            <div className="font-display text-xl text-white mt-1 mb-4">{m.handle}</div>
                            <p className="text-sm text-white/65 leading-relaxed">{m.bio}</p>
                            <div
                                className="mt-5 inline-flex items-center gap-1.5 text-xs text-white/55 group-hover:text-brand-cyan transition font-mono"
                                data-testid={`${m.testId}-link`}
                            >
                                <span>{m.linkLabel}</span>
                                <ArrowUpRight size={12} weight="bold" />
                            </div>
                        </motion.a>
                    ))}
                </div>
            </div>
        </section>
    );
};
